import { useEffect, useState } from "react";
import { useAnalyticsWrapper } from "../../../../../store/store";
import {
  Header,
  LayerContent,
  KpiGrid,
  KpiTile,
  KpiNum,
  KpiLbl,
} from "../style";
import { NoData } from "../../style";

// Section 1 — Summary KPI tiles.
// Reads woundAnalysisIncidents.kpiSummary off the consolidated /analytic/wound-analysis payload.
type KpiTileData = { label: string; value: number };

const KpiSummary = () => {
  const [tiles, setTiles] = useState<KpiTileData[]>([]);

  const { woundAnalysisIncidents } = useAnalyticsWrapper((state) => ({
    woundAnalysisIncidents: state.woundAnalysisIncidents,
  }));

  useEffect(() => {
    const kpi = woundAnalysisIncidents?.kpiSummary;
    if (kpi) {
      setTiles([
        { label: "Total Incidents", value: kpi.totalIncidents ?? 0 },
        { label: "Pressure Ulcers", value: kpi.pressureUlcers ?? 0 },
        { label: "Other Wounds", value: kpi.otherWounds ?? 0 },
        { label: "House Acquired", value: kpi.houseAcquired ?? 0 },
        { label: "On Admission", value: kpi.onAdmission ?? 0 },
        { label: "Skin Tears", value: kpi.skinTears ?? 0 },
      ]);
    } else {
      setTiles([]);
    }
  }, [woundAnalysisIncidents]);

  const title = "Summary";

  return (
    <LayerContent>
      <Header>{title}</Header>
      {tiles.length > 0 ? (
        <KpiGrid>
          {tiles.map((tile) => (
            <KpiTile key={tile.label}>
              <KpiNum>{tile.value}</KpiNum>
              <KpiLbl>{tile.label}</KpiLbl>
            </KpiTile>
          ))}
        </KpiGrid>
      ) : (
        <NoData>No Data</NoData>
      )}
    </LayerContent>
  );
};

export default KpiSummary;
